import _ from "lodash";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { InfoBar } from "ctia-ui";
import {
  getStatusTitle,
  getRequestSupplier,
  isExisted
} from "helpers/RequestHelper";

const InfoBarDHR = ({ request, sites, user }) => {
  const [{ status, vendor, modelName, hwVersion }, setBarValues] = useState({
    status: isExisted(request) ? getStatusTitle(request.status) : null,
    vendor: getRequestSupplier(request, user),
    modelName: request.modelName,
    hwVersion: user.isStaff ? request.hwVersion : null
  });

  useEffect(() => {
    const _status = isExisted(request) ? getStatusTitle(request.status) : null;
    const _vendor = getRequestSupplier(request, user);
    const _modelName = request.modelName || request.existedModel;
    const _hwVersion = user.isStaff ? request.hwVersion : null;

    setBarValues({
      status: _status,
      vendor: _vendor,
      modelName: _modelName,
      hwVersion: _hwVersion
    });
  }, [request, user]);

  const getValues = () => {
    const reqDataInfo = [
      {
        key: "Status",
        value: status
      },
      {
        key: "Vendor",
        value: vendor
      },
      {
        key: "Model Name / Number",
        value: modelName
      },
      {
        key: "HW Version",
        value: hwVersion
      }
    ];

    // remove fields with no values:
    return _.filter(reqDataInfo, field => !_.isEmpty(field.value));
  };

  return <InfoBar show={true} data={getValues()} />;
};

function mapStateToProps({ request, sites, user }) {
  return { request, sites, user };
}

export default connect(mapStateToProps)(InfoBarDHR);
